export const NUMBER_ZERO = 0;
export const NUMBER_ONE = 1;
export const NUMBER_TWO = 2;
export const NUMBER_THREE = 3;
export const NUMBER_FOUR = 4;
export const NUMBER_FIVE = 5;
export const NUMBER_SIX = 6;
export const NUMBER_SEVEN = 7;
export const NUMBER_EIGHT = 8;
export const NUMBER_NINE = 9;
export const NUMBER_TEN = 10;
export const NUMBER_ELEVEN = 11;
export const NUMBER_TWELVE = 12;
export const NUMBER_THIRTEEN = 13;
export const NUMBER_FOURTEEN = 14;
export const NUMBER_FIFTEEN = 15;
export const NUMBER_SIXTEEN = 16;
export const NUMBER_SEVENTEEN = 17;
export const NUMBER_EIGHTEEN = 18;
export const NUMBER_NINETEEN = 19;
export const NUMBER_TWENTY = 20;
export const NUMBER_TWENTY_ONE = 21;
export const NUMBER_TWENTY_TWO = 22;
export const NUMBER_TWENTY_THREE = 23;
export const NUMBER_TWENTY_FOUR = 24;
export const NUMBER_TWENTY_FIVE = 25;
export const NUMBER_TWENTY_SIX = 26;
export const NUMBER_TWENTY_SEVEN = 27;
export const NUMBER_TWENTY_EIGHT = 28;
export const NUMBER_TWENTY_NINE = 29;
export const NUMBER_THIRTY = 30;
export const NUMBER_THIRTY_ONE = 31;
export const NUMBER_THIRTY_TWO = 32;
export const NUMBER_THIRTY_THREE = 33;
export const NUMBER_THIRTY_FOUR = 34;
export const NUMBER_THIRTY_FIVE = 35;
export const NUMBER_THIRTY_SIX = 36;
export const NUMBER_THIRTY_SEVEN = 37;
export const NUMBER_THIRTY_EIGHT = 38;
export const NUMBER_THIRTY_NINE = 39;
export const NUMBER_FORTY = 40;
export const NUMBER_FORTY_ONE = 41;
export const NUMBER_FORTY_TWO = 42;
export const NUMBER_FORTY_THREE = 43;
export const NUMBER_FORTY_FOUR = 44;
export const NUMBER_FORTY_FIVE = 45;
export const NUMBER_FORTY_SIX = 46;
export const NUMBER_FORTY_SEVEN = 47;
export const NUMBER_FORTY_EIGHT = 48;
export const NUMBER_FORTY_NINE = 49;
export const NUMBER_FIFTY = 50;
export const NUMBER_FIFTY_ONE = 51;
export const NUMBER_FIFTY_TWO = 52;
export const NUMBER_FIFTY_THREE = 53;
export const NUMBER_FIFTY_FOUR = 54;
export const NUMBER_FIFTY_FIVE = 55;
export const NUMBER_FIFTY_SIX = 56;
export const NUMBER_FIFTY_SEVEN = 57;
export const NUMBER_FIFTY_EIGHT = 58;
export const NUMBER_FIFTY_NINE = 59;
export const NUMBER_SIXTY = 60;
export const NUMBER_SIXTY_ONE = 61;
export const NUMBER_SIXTY_TWO = 62;
export const NUMBER_SIXTY_THREE = 63;
export const NUMBER_SIXTY_FOUR = 64;
export const NUMBER_SIXTY_FIVE = 65;
export const NUMBER_SIXTY_SIX = 66;
export const NUMBER_SIXTY_SEVEN = 67;
export const NUMBER_SIXTY_EIGHT = 68;
export const NUMBER_SIXTY_NINE = 69;
export const NUMBER_SEVENTY = 70;
export const NUMBER_SEVENTY_ONE = 71;
export const NUMBER_SEVENTY_TWO = 72;
export const NUMBER_SEVENTY_THREE = 73;
export const NUMBER_SEVENTY_FOUR = 74;
export const NUMBER_SEVENTY_FIVE = 75;
export const NUMBER_SEVENTY_SIX = 76;
export const NUMBER_SEVENTY_SEVEN = 77;
export const NUMBER_SEVENTY_EIGHT = 78;
export const NUMBER_SEVENTY_NINE = 79;
export const NUMBER_EIGHTY = 80;
export const NUMBER_EIGHTY_ONE = 81;
export const NUMBER_EIGHTY_TWO = 82;
export const NUMBER_EIGHTY_THREE = 83;
export const NUMBER_EIGHTY_FOUR = 84;
export const NUMBER_EIGHTY_FIVE = 85;
export const NUMBER_EIGHTY_SIX = 86;
export const NUMBER_EIGHTY_SEVEN = 87;
export const NUMBER_EIGHTY_EIGHT = 88;
export const NUMBER_EIGHTY_NINE = 89;
export const NUMBER_NINETY = 90;
export const NUMBER_NINETY_ONE = 91;
export const NUMBER_NINETY_TWO = 92;
export const NUMBER_NINETY_THREE = 93;
export const NUMBER_NINETY_FOUR = 94;
export const NUMBER_NINETY_FIVE = 95;
export const NUMBER_NINETY_SIX = 96;
export const NUMBER_NINETY_SEVEN = 97;
export const NUMBER_NINETY_EIGHT = 98;
export const NUMBER_NINETY_NINE = 99;
export const NUMBER_ONE_HUNDRED = 100;
export const NUMBER_NINE_HUNDRED_NINTY_NINE = 999;
export const NUMBER_ONE_THOUSAND = 1000;
export const NUMBER_ONE_BILLION = 9990000000;
